(ns minorodata.components.forms.metadata-select
  (:require [reagent.core :as reagent]
            [re-posh.core :as re-posh]
            [clojure.set]
            [react :as react]
            [goog.functions :refer [throttle]]
            ["react-virtualized" :as VirtualList]
            [ui.fields :as fields]
            [ui.utils :refer [clsx]]
            [minorodata.components.spinner.core :as components.spinner]
            [applied-science.js-interop :as js-interop]
            [minorodata.app.utils :as app.utils]
            [minorodata.app.handlers :refer [dispatch]]
            [clojure.string :as str]))


(defn missing-option [value]
  {:value value :text (str value " — Invalid value") :disabled false})


(defn non-empty-stirng? [value]
  (and (not (nil? value))
       (not (str/blank? value))))


(defn get-diff [all-values field-value]
  (let [field-value (js->clj field-value)
        multiple? (or (seq? field-value)
                      (vector? field-value))

        desired-values (filter non-empty-stirng?
                               (if multiple? field-value [field-value]))]
    (clojure.set/difference (set desired-values)
                            (set all-values))))


(defn get-missing-values [options {:keys [value]}]
  (let [availabale-values (map :value options)

        value (js->clj value)

        multiple? (or (seq? value)
                      (vector? value))

        desired-values (filter non-empty-stirng?
                               (if multiple? value [value]))]

    (get-diff availabale-values desired-values)))


(defn render-select-options [options field]
  (let [rendered-options (mapv (fn [{:keys [value] :as option}]
                                 (assoc option :data-cy (str "menu-item-" value)))
                               options)

        diff (get-missing-values options field)

        missing-options (map missing-option diff)]
    (concat missing-options
            rendered-options)))


(defn sort-columns [evt options]
  (let [value evt
        index (reduce (fn [acc [idx option]]
                        (assoc acc option idx))
                      {}
                      ;; Options are expected to be already sorted by ordinal
                      ;; position in the DB
                      (map-indexed vector options))
        sorted (sort #(compare (get index %1) (get index %2)) value)]
    (apply vector sorted)))

(def scroll-position-cache
  (reagent/atom {:position 0
                 :key      nil}))

(defn missing-options->metadata [missing-options]
  (map (fn [option]
         {:invalid-option true
          :type-name "MISSING COLUMN"
          :column-name option})
       missing-options))

(defn filter-options [options search]
  (if (not-empty search)
    (filter (fn [column-name]
              (str/includes? (str/lower-case column-name)
                             (str/lower-case search)))
            options)
    options))

(defn toggle-selected-option [selected-options option selected?]
  (distinct
   (if selected?
     (app.utils/remove-elem selected-options option)
     (conj (js->clj selected-options) option))))

(defn multiselect [props]
  (let [scrollable-portion-ref (react/useRef nil)
        parent-ref             (react/useRef nil)

        [search set-search] (react/useState "")
        [selected-options set-selected-options] (react/useState (clj->js (distinct (:value (:field props)))))

        [scroll-position set-scroll-position] (react/useState
                                               (if (= (:options props) (:key @scroll-position-cache))
                                                 (:position @scroll-position-cache)
                                                 -1))

        [block-width set-block-width] (react/useState 400)]

    ;; Set up initial scroll position
    (react/useEffect
     (fn []
       (if (= (:options props) (:key @scroll-position-cache))
         (set-scroll-position (:position @scroll-position-cache))
         -1)

       (fn []))
     #js [])


    ;; Initialize options
    ; (react/useEffect
    ;  (fn []
    ;    (let [options       (:options props)
    ;          field         (:field props)]
    ;      (set-selected-options (clj->js (distinct (:value field)))))
    ;
    ;    (fn []))
    ;  #js [(clj->js (distinct (:value (:field props))))])



    ;; Track block width, needed for virtualized list rendering
    (react/useEffect
     (fn []
       (set-block-width
        (if (.-current parent-ref)
          (-> parent-ref
              (.-current)
              (js-interop/call :getBoundingClientRect)
              (js-interop/get :width))
          400))

       (fn []))

     #js [])

    (react/useEffect
     (fn []
       (set-scroll-position 0))
     #js [search])

    (let [{:keys [disabled field options label loading options-with-metadata data-cy]} props

          on-change (:action field)

          missing-options (get-diff options (:value field))
          missing-options-with-metadata (missing-options->metadata missing-options)

          options-with-metadata (concat missing-options-with-metadata options-with-metadata)

          all-options-selected (= (sort selected-options)
                                  (sort options))

          all-options (concat missing-options options)

          filtered-options (filter-options all-options search)

          scroll-handler (fn scroll-handler [evt]
                           (let [position (js-interop/get-in evt [:scrollTop])]
                             (when (not= -1 position)
                               (set-scroll-position position)
                               (reset! scroll-position-cache
                                       {:key      options
                                        :position position}))))

          on-scroll (throttle scroll-handler 10)]

      [:div {:class "mt-2 w-full"
             :ref parent-ref}

       [:div {:class (clsx "block w-full text-sm rounded-md border-0 ring-1 outline-0 bg-white ring-inset ring-kleene-neutral-01 placeholder:text-kleene-dark-05 focus:ring-2 focus:ring-inset focus:ring-kleene-secondary-03"
                           "dark:bg-kleene-dark-01 dark:text-kleene-neutral-01 dark:ring-kleene-dark-03 dark:focus:ring-kleene-dark-04"
                           "divide-y")}
        [:div {:class "px-2 py-4 flex"}
         [:div {:class "mr-4 ml-1 pt-3"}
          [ui.fields/checkbox
           {:on-change (fn multiselector-header-click []
                         (let [all-options (apply array (distinct options))
                               to-select (if all-options-selected
                                           ;; Can't deselect all,
                                           ;; so will select the
                                           ;; first option
                                           [(first all-options)]
                                           all-options)]
                           (set-selected-options to-select)
                           (on-change (js->clj to-select))))

            :checked (if (and (not all-options-selected)
                              (> (count selected-options) 0))
                       "indeterminate"
                       all-options-selected)

            :disabled disabled}]]
         [:div
          [:div {:class "mb-1"} label]
          [:div {:class "text-kleene-text/50 text-xs"} (str (count selected-options) "/" (count options) " selected")]]]


        (when (and loading
                   (empty? options))
          [:div {:class "p-4"}
           [components.spinner/inline-configurable {:size 32}]])

        (when (and (not loading)
                   (> (count options) 10))
          [:div {:class "p-2"}
           [fields/input {:value search
                          :placeholder "Search"
                          :type "text"
                          :variant "standard"
                          :on-change (fn [e]
                                       (let [search-term (js-interop/get-in e [:target :value])]
                                         (set-search search-term)))}]])

        [:> VirtualList/List {:ref scrollable-portion-ref

                              :on-scroll on-scroll

                              :data-cy data-cy

                              :class  "max-h-[435px]"
                              :height 435
                              :width block-width
                              :overscanRowCount 20
                              :rowCount (if loading 0 (count filtered-options))
                              :rowHeight 50
                              :scrollTop scroll-position
                              :noRowsRenderer (fn []
                                                (reagent/as-element
                                                 (if loading
                                                   [:div]
                                                   [:p {:class "opacity-50 m-8 text-center"}
                                                    "No options available"])))
                              :rowRenderer (fn [i]
                                             (reagent/as-element
                                              (let [idx (js-interop/get i :index)
                                                    visible? (js-interop/get i :isVisible)
                                                    list-key (js-interop/get i :key)

                                                    top (js-interop/get-in i [:style :top])

                                                    option (nth filtered-options idx nil)
                                                    item-selected? (app.utils/in-seq? selected-options option)
                                                    option-with-metadata (nth options-with-metadata idx nil)
                                                    type (:type-name option-with-metadata)
                                                    last-one? (and item-selected?
                                                                   (= 1 (count selected-options)))
                                                    key       (str idx option list-key item-selected?)
                                                    missing-option? (and (:invalid-option option-with-metadata)
                                                                         (not loading)
                                                                         (seq options))]
                                                [:div
                                                 {:key key
                                                  :class ["flex flex-row absolute left-0 w-full h-[50px] cursor-pointer items-center"
                                                          "border-b border-kleene-border pr-1"]
                                                  :style {"top" (str top "px")}
                                                  :data-cy (str data-cy "-" option)
                                                  :top top
                                                  :on-click (fn toggle-column-click []
                                                              (when-not last-one?
                                                                (let [new-array (toggle-selected-option selected-options option item-selected?)]

                                                                  (set-selected-options (clj->js (apply array new-array)))
                                                                  (on-change (js->clj (apply array new-array))))))}

                                                 [:div {:class "mr-4 ml-3 pointer-events-none"}
                                                  [ui.fields/checkbox {:checked item-selected?
                                                                       :disabled last-one?}]]

                                                 [:div {:class ["flex grow shrink flex-row gap-2 items-center"
                                                                (when missing-option?
                                                                  "text-kleene-error-02")]
                                                        :title (when last-one? "At least one column must be selected")}
                                                  [:div {:class "grow shrink break-all"
                                                         :title (if missing-option?
                                                                  "This column is not present in the table you selected anymore."
                                                                  option)}
                                                   option]

                                                  (when (some? type)
                                                    [:div {:class "shrink-0 text-kleene-text-dark uppercase text-xs"
                                                           :title (if missing-option?
                                                                    "This column is not present in the table you selected anymore."
                                                                    type)}
                                                     type])]])))}]]])))



(defn metadata-request-params [{:keys [fetch-type fields schema-field table-field]}]
  (let [schema    (get-in fields [schema-field :value])
        table     (get-in fields [table-field :value])]
    (case fetch-type
      :schemas      {:object "schemas"}

      :tables       (when-not (empty? schema)
                      {:object "tables"
                       :input  {:schema schema}})

      :columns      (when-not (or (empty? schema)
                                  (empty? table))
                      {:object "columns"
                       :input  {:schema schema
                                :table  table}})

      :primary-keys (when-not (or (empty? schema)
                                  (empty? table))
                      {:object "primary-keys"
                       :input  {:schema schema
                                :table  table}})
      (when (some? fetch-type)
        (js/console.warn (str "Invalid metadata request type: " fetch-type))))))


(defn metadata-loader-key [source-id request-params]
  (keyword (str "fetch-metadata-request-" source-id "-" (:object request-params) "-" request-params)))


(defn database-metadata-select' [{:keys [block fields errors options loading? req-loading? options-with-metadata]}]
  (let [source-id (get-in fields [:source-id :value])
        {:keys [disabled-text downstream-deps empty-option-text fetch-type label loading-text multiple name
                required schema-field select-all select-all-options select-all-when-empty
                skip-request table-field type upstream-deps]
         :or   {multiple false
                empty-option-text "No data"
                select-all false ;; will try to select all elements when loaded
                select-all-when-empty true ;; if select-all flag is on, will not allow the field to be empty. If user delesects all values, it will select all again
                }} block

        field (get fields name)

        make-options (fn []
                       (mapv (fn [opt]
                               (if (map? opt)
                                 opt
                                 {:text opt :value opt}))
                             (or options [])))

        dependencies      (map fields upstream-deps)
        dependency-values (map :value dependencies)

        disabled?  (if (empty? dependencies)
                     false
                     (some clojure.string/blank? dependency-values))

        rendered-options (fn [] (render-select-options (make-options) field))

        on-change (fn [evt]
                    ;; drop downstream deps
                    (doall
                     (for [dep downstream-deps
                           :let [action (get-in fields [dep :action])]]
                       (action [])))

                    ;; forward the event to initial recipient
                    ((:action field)
                     (if (and (= :columns fetch-type)
                              multiple)
                       (sort-columns evt options)
                       evt)))]

    (react/useEffect
     (fn []

       (when-not (or skip-request req-loading?)
         (when-let [params (metadata-request-params {:fetch-type   fetch-type
                                                     :fields       fields
                                                     :schema-field schema-field
                                                     :table-field  table-field})]
           (dispatch [:connections.api/fetch-source-meta
                      source-id
                      params
                      (when select-all
                        {:select-all    true
                         :current-value (:value field)
                         :fetch-type    fetch-type
                         :options-sub   [select-all-options fields]
                         :select-fn     (fn [select-options]
                                          (let [empty-options? (empty? options)


                                                should-reset? (or (and select-all-when-empty
                                                                       (empty? (:value field)))

                                                                  (and select-all-when-empty
                                                                       empty-options?
                                                                       (some? select-options)))]

                                            (when should-reset?
                                              (on-change (apply array select-options)))))})])))

       (fn []))
     #js [(str dependency-values)])

    (let [disabled-or-loading? (or loading? disabled?)
          empty-options?       (empty? options)]

      (if (and disabled-or-loading? (:inline-loader block))
        [:div {:style {:height "48px" :margin-top "16px" :margin-bottom "8px" :display "flex" :align-items "flex-end"}}
         [:span {:style {:margin-right "10px"}}
          [components.spinner/inline-configurable {:color "primary" :size 16}]]
         loading-text]

        (cond
          (= :columns fetch-type)
          [:f> multiselect
           {:options          options
            :options-with-metadata options-with-metadata
            :data-cy          (str "multiselect-" fetch-type "-" name)
            :field            (assoc field :action on-change)
            :disabled         (or disabled-or-loading? empty-options?)
            :loading          req-loading?
            :label            (cond
                                empty-options? empty-option-text
                                disabled?      disabled-text
                                :else          label)}]


          multiple
          [ui.fields/multiselect
           {:field    (assoc field :action on-change)
            :errors   errors
            :id       name
            :variant  "standard"
            :type     type
            :required required
            :multiple multiple
            :native   false
            :options  (rendered-options)
            :disabled (or disabled-or-loading? empty-options?)
            :label    label
            :placeholder (cond
                           req-loading?  loading-text
                           empty-options? empty-option-text
                           disabled?      disabled-text)
            :data-cy  (str "select-" fetch-type "-" name)}]

          :else
          (let [options (rendered-options)
                value   (:value field)]
            [(if (> (count options) 10) ui.fields/searchable-select ui.fields/select)
             {:field         (assoc field
                                    :value (if (vector? value) "" value)
                                    :action on-change)
              :errors        errors
              :id            name
              :variant       "standard"
              :type          type
              :required      required
              :multiple      false
              :native        false
              :searchable    true
              :options       options
              :disabled      (or disabled-or-loading? empty-options?)
              :label         label
              :placeholder   (cond
                               req-loading?  loading-text
                               empty-options? empty-option-text
                               disabled?      disabled-text)
              :data-cy       (str "select-" fetch-type "-" name)}]))))))

(defn database-metadata-select [{:keys [block fields] :as props}]
  (let [{:keys [options-sub fetch-type schema-field table-field options-meta-sub]} block
        source-id (get-in fields [:source-id :value])

        options @(re-posh/subscribe [options-sub fields])

        loader-key (metadata-loader-key
                    source-id
                    (metadata-request-params
                     {:fetch-type fetch-type
                      :fields fields
                      :schema-field schema-field
                      :table-field table-field}))

        loading?     @(re-posh/subscribe [:mold-http/loading? :connections.api/fetch-source-meta])
        req-loading? @(re-posh/subscribe [:mold-http/loading-id? :connections.api/fetch-source-meta loader-key])
        options-with-metadata @(if (some? options-meta-sub)
                                 (re-posh/subscribe [options-meta-sub fields])
                                 (atom nil))]

    [:f> database-metadata-select'
     (assoc props
            :options options
            :options-with-metadata options-with-metadata
            :loading? loading?
            :req-loading? req-loading?)]))
